<template>
  <ul>
    <li><v-icon :icon="['fas', 'square']" class="default-ticket"/> - Обращение в работе</li>
    <li><v-icon :icon="['fas', 'square']" class="new-ticket"/> - Новое обращение</li>
    <li><v-icon :icon="['fas', 'square']" class="to-ticket"/> - Обращение на ТО/Испытания</li>
  </ul>
</template>

<script>
export default {
  name: "ColorLegend"
}
</script>

<style scoped>
.default-ticket {
  padding: 3px;
  border-radius: 2px;
  border: 1px dashed rgba(0,0,0,0.1);
  color: transparent;
}
.new-ticket {
  padding: 3px;
  border-radius: 2px;
  border: 1px dashed rgba(0,0,0,0.1);
  background-color: rgba(45,140,0, 0.1);
  color: rgba(45,140,0, 0.1);
}
.to-ticket {
  padding: 3px;
  border-radius: 2px;
  border: 1px dashed rgba(0,0,0,0.1);
  background-color: rgba(0,0,0, 0.1);
  color: rgba(0,0,0, 0.1);
}
</style>